import { render, staticRenderFns } from "./StatisticCardIcon.vue?vue&type=template&id=0ed8ecc7&scoped=true"
import script from "./StatisticCardIcon.vue?vue&type=script&lang=ts"
export * from "./StatisticCardIcon.vue?vue&type=script&lang=ts"
import style0 from "./StatisticCardIcon.vue?vue&type=style&index=0&id=0ed8ecc7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed8ecc7",
  null
  
)

export default component.exports